export enum ChatAgentTypes {
  BOT = 'BOT',
  AGENT = 'AGENT'
}
